import { fromString } from "@bounce/date"
import type { PostCardProps } from "@bounce/web-components"

import type { FormattedEvent } from "@/libs/prismic/types"

export const getFormattedDate = ({ startDate, endDate }: FormattedEvent) => {
  if (!startDate || !endDate) return ""

  const start = fromString(startDate).toFormat("d MMMM")
  const end = fromString(endDate).toFormat("d MMMM")
  if (start === end) return start

  return `${start} - ${end}`
}

/**
 * Map an event to a post card props
 */
export const eventToPostCard = (event: FormattedEvent): PostCardProps => ({
  title: event.name,
  excerpt: event.excerpt,
  image: event.image,
  href: event.url,
  date: getFormattedDate(event),
})
